// * 베타 기준:
// - 개발 모드
// - window.location.host에 34.64.242.58 또는 amyhero가 포함
export const isBeta =
  process.env.NODE_ENV === "development" ||
  window.location.host?.includes("34.64.242.58") ||
  window.location.host?.includes("amyhero") ||
  window.location.host?.includes("beta.linkid.pw")
    ? true
    : false;

export const isDev = window.location.host?.includes("dev.linkid.pw")
  ? true
  : false;

export const serverUrl =
  process.env.NODE_ENV === "development"
    ? `${window.location.origin}/api`
    : window.location.host?.includes(":5000")
    ? "https://beta.linkid.pw:5000/api"
    : "https://in-admin.linkid.pw/api";
